<script>
import appConfig from '@/app.config'
import McButton from '@/components/McButton'
import PageHeader from '@/components/page-header-v2'
import { Export } from '@/mixin/export'
import { Helper } from '@/mixin/helper'
import { MixPanel } from '@/mixin/mixpanel'
import Layout from '@/router/layouts/main'
import moment from 'moment'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/id'
import { mapGetters } from 'vuex'
import i18n from '../../../i18n'
import MenuCard from './components/MenuCard'
import TMSReportMenu from './components/TMSReportMenu.vue'
import VSMSReportMenu from './components/VSMSReportMenu.vue'
import menuList from './lib/domainMenuList'

moment.locale('id')
/**
 * Starter component
 */
export default {
  page: {
    title: 'Report',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    MenuCard,
    McButton,
    TMSReportMenu,
    VSMSReportMenu,
  },
  mixins: [Export, Helper, MixPanel],
  data() {
    return {
      filter: null,
      search: {
        fleet: null,
        driver: null,
        vehicle: null,
      },

      isAddFavorit: false,
      addFavorit: null,

      report: '',
      reportOptions: [],
      favorit: '',

      domain: this.$route.query.domain ? this.$route.query.domain : null,
      favoriteReports: {
        favoriteReports: {
          userId: 0,
          favoriteReportKeys: [],
        },
      },
      render: true,
    }
  },

  computed: {
    /**
     * Total no. of records
     */
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      hasAccessAll: 'identity/hasAccessAll',
      isNewSubmodule: 'identity/isNewSubmodule',
    }),

    title() {
      return this.domain === 'fleet'
        ? ''
        : this.isDomainView && !this.domain
        ? 'Domain'
        : this.$t('menuitems.laporan.text')
    },

    items() {
      return [
        {
          text: this.$t('menuitems.laporan.text'),
        },
      ]
    },

    menuList() {
      return menuList.filter((menu) => menu.shown)
    },

    isDomainView() {
      return this.hasAccess(['tms:create', 'tms:read', 'tms:update', 'tms:delete'])
    },
  },

  created() {
    i18n.locale = localStorage.getItem('language')
  },

  async mounted() {
    this.track('Landing Page Report')
    if (this.hasAccess(['favorite-reports:read'])) {
      await this.$store.dispatch('report/setFavoriteReport')
    }
  },

  methods: {
    changeDomain(dom) {
      this.render = true
      this.domain = dom
    },

    resetDomain() {
      this.render = false
      this.domain = null
      if (this.$route.query.domain) {
        this.$router.replace({ name: 'Report' })
      }
      this.resetPage()

      setTimeout(() => {
        this.render = true
      }, 500)
    },
    resetPage() {
      this.report = ''
      this.reportOptions = []
      this.favorit = ''
      this.filter = null
      this.domain = null
      this.favoriteReports = {
        favoriteReports: {
          userId: 0,
          favoriteReportKeys: [],
        },
      }
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title">
      <template #afterTitle>
        <div class="d-flex gap-2">
          <McButton
            variant="secondary"
            :text="$t('global.back')"
            icon="icon-outline_arrow-left"
            @click="resetDomain()"
            v-if="domain"
          />
        </div>
      </template>
    </PageHeader>

    <TMSReportMenu v-if="domain === 'delivery'" />

    <VSMSReportMenu v-else-if="(domain === 'fleet' || !isDomainView) && render" />

    <b-row v-else>
      <MenuCard
        v-for="menu in menuList"
        :key="$t(menu.title)"
        :title="$t(menu.title)"
        :description="$t(menu.desc)"
        @click="changeDomain(menu.domain)"
        :badge="`${menu.badge ? $t(menu.badge.text) : ''}`"
        hasShadow
      />
    </b-row>
  </Layout>
</template>
